// extracted by mini-css-extract-plugin
export var cardLayout = "fp-Rn";
export var cardLayout2 = "fp-Tn";
export var cardLayout3 = "fp-Un";
export var cardLayout4 = "fp-Vn";
export var cardLayout__item = "fp-Sn";
export var mt0 = "fp-Kn";
export var mt1 = "fp-Ln";
export var mt2 = "fp-Mn";
export var mt3 = "fp-Nn";
export var mt4 = "fp-On";
export var mt5 = "fp-Pn";
export var mt6 = "fp-Qn";